import { ComponentRoute } from '@/classes'

const ProductionInOutRoutes = {
  ProductionInOutView: new ComponentRoute('/productioninout', 'ProductionInOutView')
}

export default ProductionInOutRoutes